import { BaseComponent } from "../BaseComponent";
import { ComponentNames } from 'src/app/helper/componentNames';

export class SeatComponent extends BaseComponent{
    constructor(){
        super();
        this.componentType = ComponentNames.seatComponent;
    }
    seatAmountEditable:boolean;
    seatAmount:number;
}